var _excluded = ["parts", "highlightedTagName", "nonHighlightedTagName", "separator", "className", "classNames"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { Fragment } from 'react';
import { cx } from "./lib/cx.js";
function HighlightPart(_ref) {
  var classNames = _ref.classNames,
    children = _ref.children,
    highlightedTagName = _ref.highlightedTagName,
    isHighlighted = _ref.isHighlighted,
    nonHighlightedTagName = _ref.nonHighlightedTagName;
  var TagName = isHighlighted ? highlightedTagName : nonHighlightedTagName;
  return /*#__PURE__*/React.createElement(TagName, {
    className: isHighlighted ? classNames.highlighted : classNames.nonHighlighted
  }, children);
}
export function InternalHighlight(_ref2) {
  var parts = _ref2.parts,
    _ref2$highlightedTagN = _ref2.highlightedTagName,
    highlightedTagName = _ref2$highlightedTagN === void 0 ? 'mark' : _ref2$highlightedTagN,
    _ref2$nonHighlightedT = _ref2.nonHighlightedTagName,
    nonHighlightedTagName = _ref2$nonHighlightedT === void 0 ? 'span' : _ref2$nonHighlightedT,
    _ref2$separator = _ref2.separator,
    separator = _ref2$separator === void 0 ? ', ' : _ref2$separator,
    className = _ref2.className,
    classNames = _ref2.classNames,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement("span", _extends({}, props, {
    className: cx(classNames.root, className)
  }), parts.map(function (part, partIndex) {
    var isLastPart = partIndex === parts.length - 1;
    return /*#__PURE__*/React.createElement(Fragment, {
      key: partIndex
    }, part.map(function (subPart, subPartIndex) {
      return /*#__PURE__*/React.createElement(HighlightPart, {
        key: subPartIndex,
        classNames: classNames,
        highlightedTagName: highlightedTagName,
        nonHighlightedTagName: nonHighlightedTagName,
        isHighlighted: subPart.isHighlighted
      }, subPart.value);
    }), !isLastPart && /*#__PURE__*/React.createElement("span", {
      className: classNames.separator
    }, separator));
  }));
}